export function subnav() {
	const subnav = document.getElementById("subnav");
	if (!subnav) return;

	let subnavOpen = false;
	const subnavTrigger = document.getElementById("subnavTrigger");
	const svgGroups = subnavTrigger.querySelectorAll("g");

	const switchSvgGroups = () => {
		svgGroups.forEach((g) => {
			if (g.classList.contains("opacity-0")) {
				g.classList.remove("opacity-0");
				g.classList.add("opacity-100");
			} else {
				g.classList.remove("opacity-100");
				g.classList.add("opacity-0");
			}
		});
	};

	const doClickAway = (e) => {
		if (!subnav.contains(e.target)) {
			doClose();
		}
	};

	const doOpen = () => {
		subnavOpen = true;
		switchSvgGroups();
		subnav.classList.add("-translate-y-full");
		document.addEventListener("click", doClickAway);
	};

	const doClose = () => {
		subnavOpen = false;
		switchSvgGroups();
		subnav.classList.remove("-translate-y-full");
		document.removeEventListener("click", doClickAway);
	};

	subnavTrigger.addEventListener("click", () => {
		return subnavOpen ? doClose() : doOpen();
	});
}
